import * as Sentry from "@sentry/react";
import type { RuntimeEnvironment } from "app/Firebase";
import { shouldSendToSentry } from "lib/sentry/errorReporting";
import { getApiUrlForEnvironment } from "lib/apiUrlConfig";

type SentryInitOptions = NonNullable<Parameters<typeof Sentry.init>[0]>;
type InitSentryOptions = Pick<SentryInitOptions, "transport">;
type SentryIntegrations = Exclude<SentryInitOptions["integrations"], undefined>;
type SentryIntegrationsFn = Extract<
  SentryIntegrations,
  (integrations: any[]) => any[]
>;
type SentryIntegration = Parameters<SentryIntegrationsFn>[0][number];

const sentryDsn =
  "https://55b7486698025f0a90935007b70807bc@o515028.ingest.sentry.io/4506107431026688";

export const sentryTunnelPath = "/api/sentry";

export const configureSentryIntegrations = (
  defaultIntegrations: SentryIntegration[],
) =>
  defaultIntegrations.map((integration) =>
    integration.name === "Breadcrumbs"
      ? Sentry.breadcrumbsIntegration({ console: false })
      : integration,
  );

export const initSentry = (
  environment: RuntimeEnvironment,
  options: InitSentryOptions = {},
) =>
  Sentry.init({
    dsn: sentryDsn,
    environment,
    // Keep browser traffic on the Job Manager API so managed blockers do not block Sentry's ingest domain.
    tunnel: getApiUrlForEnvironment(environment, sentryTunnelPath),
    integrations: configureSentryIntegrations,
    beforeSend: (event) => (shouldSendToSentry(environment) ? event : null),
    beforeBreadcrumb: (breadcrumb) =>
      shouldSendToSentry(environment) ? breadcrumb : null,
    ...options,
  });
